import React,{useState,useEffect} from "react"
import '../Styles/ProjectPage.css';
import { getByIdProductos } from '../Services/services'
import Loading from '../Components/Loading';
import {useParams} from "react-router-dom"

function ProjectPage(props) {

    const {id} = useParams();
    const [project,setProject] = useState([]);
    const [loading,setLoading] = useState(true);

    useEffect(
        ()=>{
            try{
                const request = async ()=>{
                    const response = await getByIdProductos(id)
                    console.log("response",response)
                    setLoading(false)
                    setProject(response)
                }
                request()
            } catch(e) {
                setLoading(false)
                console.log(e)
            } 
        },
        [id]
    )

    if (loading) {
        return (
            <Loading />
        )
    } else {
        return (
            <div className="ProjectPage">
                <div className="ProjectPage__title" data-aos="fade-zoom-in" data-aos-delay="300" data-aos-duration="1500">
                    <h2>{project.data().name}</h2>
                </div>
                <a className="ProjectPage__img" href={project.data().link} target="_blank" rel="noreferrer" data-aos="zoom-in" data-aos-delay="500" data-aos-duration="2500">
                    <img src={project.data().img} alt="" />
                </a>
                {
                props.language === props.uk ?
                <div className="ProjectPage__text">
                    {project.data().about.map(projectData =>
                        <div className="ProjectPage__textAbout" data-aos="fade-zoom-in" data-aos-delay="300" data-aos-duration="1500">
                            <p>{projectData}</p>
                            <br />
                        </div>
                    )}
                </div>
                :
                <div className="ProjectPage__text">
                    {project.data().aboutEs.map(projectData =>
                        <div className="ProjectPage__textAbout" data-aos="fade-zoom-in" data-aos-delay="300" data-aos-duration="1500">
                            <p>{projectData}</p>
                            <br />
                        </div>
                    )}
                </div>
                }
            </div>
        );
    }
}

export default ProjectPage;